<div class="chat-team d-flex flex-column h-100">

  <!-- Header -->
  <div class="chat-team__header border-bottom px-3 py-2 flex-shrink-0">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div>
        <h5 class="m-0">{{ 'chat.team.title' | translate }}</h5>
        <small class="text-muted">{{ 'chat.team.subtitle' | translate }}</small>
      </div>
      <span class="badge bg-soft-success text-success">
        <i class="ri-checkbox-blank-circle-fill me-1"></i>{{ 'chat.team.onlineCount' | translate:{ count: onlineCount } }}
      </span>
    </div>

    <div class="input-group input-group-sm">
      <span class="input-group-text"><i class="ri-search-line"></i></span>
      <input
        type="text"
        class="form-control"
        name="chatTeamSearch"
        [placeholder]="'chat.team.searchPlaceholder' | translate"
        [attr.aria-label]="'chat.team.searchPlaceholder' | translate"
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
      >
      @if (searchTerm) {
        <button
          type="button"
          class="btn btn-light"
          (click)="clearSearch()"
          [attr.aria-label]="'chat.team.clearSearch' | translate"
        >
          <i class="ri-close-line"></i>
        </button>
      }
    </div>

    @if (directoryLoading) {
      <small class="text-muted d-block mt-1">
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>{{ 'chat.team.loading' | translate }}
      </small>
    }
  </div>

  <!-- Rows -->
  <div class="chat-team__list flex-grow-1 overflow-auto">
    @if (rows.length === 0) {
      <div class="d-flex flex-column align-items-center justify-content-center gap-2 py-5 px-3 text-center">
        <!-- Soft disc + semantic glyph on the `avatar-title` itself — see the
             note in chat-empty-state.component.html. -->
        <div class="avatar-sm">
          <i class="ri-team-line avatar-title rounded-circle bg-soft-primary text-primary font-18"></i>
        </div>
        <h5 class="mb-0">{{ 'chat.team.empty' | translate }}</h5>
        <span class="text-muted">{{ 'chat.team.emptyHint' | translate }}</span>
      </div>
    } @else {
      <div class="list-group list-group-flush">
        @for (row of rows; track trackRow($index, row)) {
          <div class="list-group-item d-flex align-items-center gap-2 py-2">
            <!-- Same avatar tile as every other chat surface — sized for the
                 two-letter initials, presence dot anchored to the corner. -->
            <span class="chat-avatar-tile flex-shrink-0">
              @if (row.image) {
                <img [src]="row.image" [alt]="row.name">
              } @else {
                {{ row.initial }}
              }
              <span
                class="chat-avatar-tile__presence rounded-circle"
                [ngClass]="row.view.dotClass"
                aria-hidden="true"
              ></span>
            </span>

            <span class="flex-grow-1 overflow-hidden">
              <span class="d-flex align-items-center gap-1">
                <span class="chat-name fw-semibold">{{ row.name }}</span>
                @if (row.isSelf) {
                  <small class="text-muted flex-shrink-0">{{ 'chat.team.yourself' | translate }}</small>
                }
                @if (row.view.emoji) {
                  <span class="flex-shrink-0">{{ row.view.emoji }}</span>
                }
              </span>
              <!-- Custom-status line. "Nenhum status definido" ONLY when there
                   is truly no status — an emoji-only status (already rendered
                   beside the name) must not be denied by this line. -->
              @if (row.view.text) {
                <small class="d-block text-truncate text-muted">{{ row.view.text }}</small>
              } @else if (!row.view.hasCustomStatus) {
                <small class="d-block text-truncate text-muted">{{ 'chat.team.noStatus' | translate }}</small>
              }
            </span>

            <span class="badge flex-shrink-0" [ngClass]="row.view.badgeClass">
              {{ row.view.labelKey | translate }}
            </span>
          </div>
        }
      </div>
    }
  </div>
</div>
